module.exports = __webpack_public_path__ + "img/014.c6ec9319.png";